module.exports = __webpack_public_path__ + "img/pp-39.223d7d85.jpg";